(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["icon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mulroom-vendor-artwork')) {
    customElements.define('mulroom-vendor-artwork', class extends HTMLElement {
      connectedCallback() {
        if (this.image) return;
        this.image = this.querySelector('img');
        if (!this.image) return;
        if (this.image.complete && this.image.naturalWidth) {
          this.measureArtwork();
        } else {
          this.image.addEventListener('load', () => this.measureArtwork(), { once: true });
        }
      }

      measureArtwork() {
        if (!this.isConnected || !this.image.naturalWidth || !this.image.naturalHeight) return;
        try {
          // Inspect a bounded, local copy; the original file and its colours stay intact.
          const scale = Math.min(1, 800 / Math.max(this.image.naturalWidth, this.image.naturalHeight));
          const canvas = document.createElement('canvas');
          canvas.width = Math.max(1, Math.round(this.image.naturalWidth * scale));
          canvas.height = Math.max(1, Math.round(this.image.naturalHeight * scale));
          const context = canvas.getContext('2d', { willReadFrequently: true });
          if (!context) return;
          context.drawImage(this.image, 0, 0, canvas.width, canvas.height);
          const pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
          const width = canvas.width;
          const height = canvas.height;
          const corners = [0, width - 1, (height - 1) * width, height * width - 1];
          const transparentBorder = corners.every(index => pixels[index * 4 + 3] <= 16);
          const whiteBorder = corners.every(index => {
            const offset = index * 4;
            return pixels[offset + 3] >= 240 && pixels[offset] >= 245 && pixels[offset + 1] >= 245 && pixels[offset + 2] >= 245;
          });
          let left = 0;
          let top = 0;
          let right = width - 1;
          let bottom = height - 1;
          if (transparentBorder || whiteBorder) {
            left = width;
            top = height;
            right = -1;
            bottom = -1;
            for (let y = 0; y < height; y++) {
              for (let x = 0; x < width; x++) {
                const offset = (y * width + x) * 4;
                const visible = pixels[offset + 3] > 16 && (transparentBorder || pixels[offset] < 245 || pixels[offset + 1] < 245 || pixels[offset + 2] < 245);
                if (!visible) continue;
                left = Math.min(left, x);
                right = Math.max(right, x);
                top = Math.min(top, y);
                bottom = Math.max(bottom, y);
              }
            }
            if (right < left || bottom < top) return;
            // Keep one sample pixel around the mark to preserve antialiased edges.
            left = Math.max(0, left - 1);
            top = Math.max(0, top - 1);
            right = Math.min(width - 1, right + 1);
            bottom = Math.min(height - 1, bottom + 1);
          }
          const artworkWidth = right - left + 1;
          const artworkHeight = bottom - top + 1;
          this.style.setProperty('--vendor-artwork-ratio', String(artworkWidth / artworkHeight));
          this.style.setProperty('--vendor-source-width', String(width / artworkWidth));
          this.style.setProperty('--vendor-source-height', String(height / artworkHeight));
          this.style.setProperty('--vendor-artwork-left', `${-100 * left / artworkWidth}%`);
          this.style.setProperty('--vendor-artwork-top', `${-100 * top / artworkHeight}%`);
          this.setAttribute('data-artwork-ready', '');
        } catch {
          // Unsupported or cross-origin images retain the standard proportional fallback.
          this.setAttribute('data-artwork-fallback', '');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
